import React from 'react';
import './App.css';
import Dashboard from './components/Dashboard';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>User Tracking Dashboard</h1>
        <p>Program Usage Analytics</p>
      </header>
      <main>
        <Dashboard />
      </main>
    </div>
  );
}

export default App;
